<!--<app-splash-screen></app-splash-screen>-->
<router-outlet></router-outlet>
<ngx-ui-loader [fgsTemplate]="foregroundSpinner"></ngx-ui-loader>

<ng-template #foregroundSpinner>
    <img src="./assets/media/project-logos/Logo.png" class="max-h-90px" alt=""/>
<!--    <div class="mosaic-loader">-->
<!--        <div class="cell d-0"></div>-->
<!--        <div class="cell d-1"></div>-->
<!--        <div class="cell d-2"></div>-->
<!--        <div class="cell d-3"></div>-->
<!--        <div class="cell d-1"></div>-->
<!--        <div class="cell d-2"></div>-->
<!--        <div class="cell d-3"></div>-->
<!--        <div class="cell d-4"></div>-->
<!--        <div class="cell d-2"></div>-->
<!--        <div class="cell d-3"></div>-->
<!--        <div class="cell d-4"></div>-->
<!--        <div class="cell d-5"></div>-->
<!--        <div class="cell d-3"></div>-->
<!--        <div class="cell d-4"></div>-->
<!--        <div class="cell d-5"></div>-->
<!--        <div class="cell d-6"></div>-->
<!--    </div>-->
</ng-template>

